import React from "react";

export default class Warning extends React.Component {
  render() {
    return (
      <div className="col-12">
        {this.props.type === "error" ? (
          <p className="text-danger">
            <strong>Eroare:</strong> {this.props.message}
          </p>
        ) : (
          <p>{this.props.message}</p>
        )}
      </div>
    );
  }
}
